import { Badge, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { FiArrowUpCircle } from 'react-icons/fi'

export const UpgradeBadge: FC = () => (
  <Badge
    variant="solid"
    colorScheme="blue"
    display="flex"
    alignItems="center"
    gap={1}
    position="absolute"
    right="0"
    top="-12px"
    zIndex="10"
    px={2}
    py="2px"
    bgGradient="linear(to-r, customBlue.100, customBlue.500)"
    borderRadius="full"
  >
    <FiArrowUpCircle size={16} />
    <Text>Upgrade</Text>
  </Badge>
)

export default UpgradeBadge
